export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-battery-empty-81806f8c34d92aef1e1221d5d71347bb.svg";